import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 20px;
  height: 362px;
  padding: 0 131px 0 131px;
  justify-content: space-between;
  align-items: center;
	background: linear-gradient(116deg, #B81570 22.96%, #CC092F 112.26%);

  @media(max-width: 1050px) {
    padding: 0 50px 0 50px;
  }

  @media(max-width: 1023px) {
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }

  @media(max-width: 767px) {
    flex-direction: column;

    gap: 16px;
    height: auto;
    padding: 24px 50px 32px 50px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & span {
    @media(min-width: 1116px) {
      display: none;
    }
  }
`

export const ImageContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media(max-width: 1116px) {
    display: none;
  }
`

export const BackgroundImage = styled.img`
  width: 100%;
`

export const TextIntro = styled.span`
  font-family: 'Platform Web';
  line-height: 18px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
`;

export const Title = styled.h1`
  margin: 0;

  font-family: 'Platform Web';
  line-height: 55px;
  color: ${(props) => props.cor};
  font-weight: 500;
  font-size: 48px;
  max-width: 500px;
  text-align: left;

  @media(max-width: 1260px) {
    font-size: 40px;
    line-height: 40px;
  }

  @media(max-width: 767px) {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }
`;

export const Button = styled.button`
  display: flex;
  padding: 17px 32px;
  justify-content: center;
  align-items: center;

  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18.77px;
  border: 1px solid transparent;
  color: ${({ color }) => color};
  border-radius: 100px;
  background: ${({ background }) => background};
  transition: all 0.5s;

  &:hover {
    border-color: #fff;
    color: #fff;
    background: transparent;
  }
`